import { Injectable } from '@angular/core';
import {
  AdMob,
  AdOptions,
  InterstitialAdPluginEvents
} from '@capacitor-community/admob';
import { environment } from '@/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AdmobService {
  public async init(): Promise<void> {
    await AdMob.initialize();
  }

  public showInterstitial(adId: string): Promise<void> {
    return new Promise(async (resolve, reject) => {
      try {
        await AdMob.prepareInterstitial({
          adId,
          isTesting: !environment.production
        });
        const dismissListener = await AdMob.addListener(
          InterstitialAdPluginEvents.Dismissed,
          () => {
            dismissListener.remove();
            errorListener.remove();
            resolve();
          }
        );
        const errorListener = await AdMob.addListener(
          InterstitialAdPluginEvents.FailedToLoad,
          err => {
            dismissListener.remove();
            errorListener.remove();
            reject(err);
          }
        );
        await AdMob.showInterstitial();
      } catch (err) {
        reject(err);
      }
    });
  }
}
